const zh = {
	login:{
        //Login main page
		MS_ENERGY: '美克生能源',
		Battery_Matrix: '计算平台',
        MS_ENERGY_Battery_Matrix:'美克生诊断计算平台',
        Account: '请输入账户',
        Password: '请输入密码',
        Forget_Password: '忘记密码?',
        Register_for_free: '免费注册',
        Read_and_accept: '我已阅读并同意',
        UserAgreement: '用户协议',
        PrivacyPolicy: '隐私政策',
        log: '登录',
        //Login forget password
        back: '返回',
        next: '下一步',
        email: '邮箱',
        Please_enter_your_email: '请输入您的邮箱',
        //Login register
        Welcome: '欢迎注册美克生诊断计算平台',
        cellphone:'电话',
        company:'单位名称',
        username:'用户名',
        password:'密码',
        confirmation:'确认密码',
        register: '确认注册'
	},
    Main:
    {
        //header
        Battery_Matrix: '诊断计算平台',
        diagnosis_management: '诊断报告管理',
        Data_Management:'项目管理',
        Battery_Balance: '锂电池组均衡仪',
        Contact_Us: '联系我们',
        Help: '帮助',
        User_Agreement: '用户协议',
        //main
        Select_template: '请选择数据模板',
        Download_Template:'下载模板',
        Select_File: '请选择文件',
        Upload_Data: '上传数据',
        Select_Project: '请选择项目',
        Reset: '重置',
        Uploading:'上传中',
        Uploaded:'上传完成',
        File_Validating: '文件校验',
        Format_error: '文件格式错误，请重新上传',
        No_file_selected: '未选择文件',
        selectDataTemplate: '请选择数据模板',
        zip: '上传文件只能是zip格式!',
        fileSize:'上传文件大小不能超过 500MB!',
        //Datatable
        number: '编号',
        projectName: '项目名称',
        DiagnoseFiles: '诊断文件',
        CreateTime: '创建时间',
        Status: '状态',
        DiagnoseTime: '诊断时间',
        DiagnoseReport: '诊断报告',
        //DataUploadDialog
        Create_New_Project: "创建新项目",
        Project_Name: "项目名称",
        Data_Type: "数据类型",
        Data_Type_Select: ["电动车", "储能电站"],
        Please_Select: "请选择",
        Choose_project: "选择原项目",
        Diagnose_Now: '立即诊断',
        Diagnose_Later:'稍后诊断',
        Diagnosed:'诊断完成',
        Diagnosing:'诊断中',
        请输入项目名称:'请输入项目名称',
        请选择数据类型:'请选择数据类型',
        请选择项目: '请选择项目',
        validationFailed: "校验失败",
        uploadFailed: "文件上传失败",
        projectNameRepeat: "项目名不可重复",

    }
	
}
export default zh;//导出